/** Stable numeric IDs for auto-popup coordination across apps */
export enum AutoPopupKey {
	// Galaxy – onboarding (10–29)
	RevisionNotice = 10,

	// Galaxy – winning / urgent (30–39)
	WcPromotionPrize = 30,
	GoldenDuelAward = 31,
	CwcJackpotWinningNotify = 32,
	SportEventWinnerNotify = 33,
	WinnerListModal = 34,

	// Galaxy – site-wide promo (40–59)
	VersionUpgrade = 40,
	RewardAnnouncement = 41,
	WcPromotionVip = 42,
	PromotionActivity = 50,
	VsTournament = 51,
	GoldenDuelPromo = 52,
	BoxingPromo = 53,
	NewbieModal = 58,
	VoucherPromoModal = 59,

	// Galaxy – route / feature entry (60–79)
	RevisionTutorial = 60,
	FeatureUpdated = 61,
	ScoreChallengeRules = 62,
	GoldenDuelRulesPopup = 63,
	WcPromotionHowModal = 64,

	// Achievement System – gift popup (65–79)
	NotUsed = 65,
	BeginnersPack = 66,
	RewardGift = 67,
	OddsBoosterGift = 68,
	LevelupPopup = 69,
	SignInSpinPopup = 70,
	SignInResultPopup = 71,
	NewVersionPopup = 72,
	PurchaseConfirm = 73,
	UM = 74,
	JackPotNotice = 75,
	RfbInfo = 76,

	// Athena – auth (80–89); higher number shows first when orderConfig is empty
	MemberLogin = 80,
	SignUp = 81,
	ForgetPassword = 82,
	PopupBannerList = 83,
}
